import { createSlice } from '@reduxjs/toolkit';
import type { ProductionOrder } from '../utils/types';
import { getProductionOrderById } from './production-order.thunk';

interface ProductionOrderState {
  loading: boolean;
  productionOrderData: ProductionOrder | null;
  error: string | null;
}

const initialState: ProductionOrderState = {
  loading: false,
  productionOrderData: null,
  error: null,
};

const productionOrderSlice = createSlice({
  name: 'productionOrder',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getProductionOrderById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductionOrderById.fulfilled, (state, action) => {
        state.productionOrderData = action.payload;
        state.loading = false;
      })
      .addCase(getProductionOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload ??
          action.error.message ??
          'Failed to fetch production order by ID';
      });
  },
});

export default productionOrderSlice.reducer;
